// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase', //defaultauth: 'fakebackend',
  firebaseConfig : {
    apiKey: "AIzaSyCkLljMa2mOztq9bctdx6KeFZmMB2h_ceA",
    authDomain: "hepcon-9da38.firebaseapp.com",
    databaseURL: "https://hepcon-9da38.firebaseio.com",
    projectId: "hepcon-9da38",
    storageBucket: "hepcon-9da38.appspot.com",
    messagingSenderId: "850496050850",
    appId: "1:850496050850:web:1d67bffc10e4fb0146a9fb",
    measurementId: "G-552GP07TG7"
  },
  resyncFuncUrl : 'https://us-central1-hepcon-9da38.cloudfunctions.net/resyncEvent'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
